import { createWingsClient } from './wings-api-client';
import { stripServerRequestPrefixes, addServerRequestPrefixes } from './wings-utils';
export { createWingsClient as createClient, stripServerRequestPrefixes as stripPrefixes, addServerRequestPrefixes as addPrefixes };